export default function formatAddress(streetAddress, city, state, zip) {
  return `${[streetAddress, city, state].filter(Boolean).join(", ")}${
    zip ? ` ${zip}` : ""
  }`;
}
